import { useEffect } from 'react';

import styled from '@emotion/styled';

import { useQuery } from '@tanstack/react-query';

import { getInvoicesByCustomer } from '../../Invoices/apiService';

import { getAppliedPayments } from '../apiService';

import { Grid, Checkbox, TextField } from '@mui/material';

import { useFormikContext } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import { BasicFlex } from '../../../utils/Common';

import NoItems from '../../../utils/NoItems';

import { formatGenericDate, formatCurrency } from '../../../utils/util';

import PaidRoundedIcon from '@mui/icons-material/PaidRounded';

const InvoiceLine = styled(BasicFlex)`
  gap: 1rem;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.border};
`;

const InvoiceHeaderLine = styled(InvoiceLine)`
  text-transform: uppercase;
  font-weight: 500;
`;

const InvoiceField = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  /* text-align: center; */
  border-right: 1px solid ${props => props.theme.colors.border};
  padding: 1rem;
  height: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: ${props => props.$justify || "center"};
`

const CheckField = styled(InvoiceField)`
  max-width: 5rem;
`

const AmountField = styled(InvoiceField)`
  max-width: 15rem;
  border-right: none;
`;

const getPaymentList = async (customer_id, payment_id, invoice_id) => {
  console.log(customer_id, payment_id, invoice_id, "getPaymentList");
  try {
    let invoices = await getInvoicesByCustomer(customer_id, "open", invoice_id);
    if (invoices.length) {
      invoices = invoices.map(el => ({ 
        invoice_id: el.invoice_id,
        due_date: el.due_date,
        total: el.total,
        balance: el.balance, 
        amount: "", 
        selected: false 
        }));
    }
    let past_payments = [];
    if (payment_id) {
      past_payments = await getAppliedPayments(payment_id);
      if (past_payments?.length) {
        past_payments = past_payments.map(el => ({
            payment_id: el.payment_id, 
            invoice_id: el.invoice_id,
            due_date: el.due_date,
            total: el.total,
            balance: +el.balance + +el.amount, 
            amount: el.amount, 
            selected: true 
          }));
          invoices = invoices.filter(el => !past_payments.find(p => p.invoice_id === el.invoice_id));
          invoices = invoices.concat(past_payments);
      }
    }
    return invoices;
  } catch (e) {
    return null;
  }
}

const OpenInvoices = () => {

  const { values } = useFormikContext() || {};

  const { formValues, setFormValues } = useFormData() || {};

  let payment_amount = values.total_amount ?? values.amount ?? 0;

  console.log(payment_amount, "payment_amount");

  const { data: invoices } = useQuery({
    queryKey: ['invoices', 'customer', values?.customer_id, values?.invoice_id],
    queryFn: () => getPaymentList(values?.customer_id, values?.payment_id, values?.invoice_id),
    enabled: !!values?.customer_id,
  })

  useEffect(() => {
    setFormValues(ofv => ({ ...ofv, 
        applied_payments: invoices
   }));
  }, [invoices]);

  let applied_payments = formValues?.applied_payments || [];

  const handleChangeAmount = (e, index) => {
    let amount = e.target.value;
    
    setFormValues(ofv => {
      const newAppliedPayments = [...ofv.applied_payments.map(el => ({ ...el }))];
      let payment = newAppliedPayments[index];
      let remaining_amount = payment_amount - (newAppliedPayments.slice(0, index).filter(el => el?.selected).reduce((a, b) => a + b?.amount, 0) || 0);
      amount = amount === "" ? "" : Math.min(amount, payment.balance, remaining_amount);
      newAppliedPayments[index] = { ...newAppliedPayments[index], amount, selected: true };
      return { ...ofv, applied_payments: newAppliedPayments };
    });
  }

  const handleChangeSelect = (e, index) => {
    if (payment_amount <= 0) return;
    let remaining_amount = payment_amount - (applied_payments.slice(0, index).filter(el => el?.selected).reduce((a, b) => a + b?.amount, 0) || 0);
    if (remaining_amount <= 0) return;
    let checked = e.target.checked;
    let payment = applied_payments[index];
    let amount = Math.min(payment.balance, remaining_amount);
    const newAppliedPayments = [...applied_payments];
    newAppliedPayments[index] = { ...newAppliedPayments[index], selected: checked, amount: checked ? amount : "" };
    setFormValues(ofv => ({ ...ofv, applied_payments: newAppliedPayments }));
  }

  return (
    <Grid size={{xs: 12}} sx={{backgroundColor: invoices?.length ? "bg.light" : "transparent", padding: "1rem", borderRadius: "0.5rem"}}>
      {invoices?.length ? <BasicFlex dir="column" my="1rem">
        <InvoiceHeaderLine>
          <CheckField><Checkbox size="small" checkedIcon={<PaidRoundedIcon />} /></CheckField>
          <InvoiceField $justify="flex-start">Description</InvoiceField>
          <InvoiceField $justify="flex-start">Due Date</InvoiceField>
          <InvoiceField $justify="flex-end">Original Amount</InvoiceField>
          <InvoiceField $justify="flex-end">Open Balance</InvoiceField>
          <AmountField $justify="flex-end">Payment</AmountField>
        </InvoiceHeaderLine>
        {applied_payments?.map((invoice, i) => (
          <InvoiceLine key={invoice.invoice_id}>
            <CheckField><Checkbox size="small" checked={!!invoice.selected} checkedIcon={<PaidRoundedIcon />} onChange={(e) => handleChangeSelect(e, i)} /></CheckField>
            <InvoiceField $justify="flex-start">#{invoice.invoice_id}</InvoiceField>
            <InvoiceField $justify="flex-start">{formatGenericDate(invoice.due_date, "short")}</InvoiceField>
            <InvoiceField $justify="flex-end">{formatCurrency(invoice.total)}</InvoiceField>
            <InvoiceField $justify="flex-end">{formatCurrency(invoice.balance)}</InvoiceField>
            <AmountField $justify="flex-end"><TextField size="small" type="number" value={invoice.amount} onChange={(e) => handleChangeAmount(e, i)} slotProps={{ input: {style: {backgroundColor: "white"}} }} /></AmountField>
          </InvoiceLine>
        ))}
      </BasicFlex> : <NoItems title="No Open Invoices" />}
    </Grid>
  )
  
};

export default OpenInvoices;